/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <div class="mc-form-register">
    <div class="mc-form-register-input">
      <br />

      <ion-label
        style="text-align: start; margin-bottom: 5px"
        class="no-white-space"
        ><p>{{ $t("HitchHiking.register.hikeTitle") }} *</p></ion-label
      >
      <ion-radio-group>
        <ion-item lines="none">
          <ion-radio
            label-placement="end"
            name="hitchHikeDriver"
            color="success"
            slot="start"
            @ionSelect="changeHitchHikeDriver($event)"
            :checked="user.hitchHikeDriver && !user.hitchHikePassenger"
            >{{ $t("HitchHiking.register.driver") }}</ion-radio
          >
        </ion-item>
        <ion-item lines="none">
          <ion-radio
            label-placement="end"
            name="hitchHikePassenger"
            color="success"
            slot="start"
            @ionSelect="changeHitchHikePassenger($event)"
            :checked="user.hitchHikePassenger && !user.hitchHikeDriver"
            >{{ $t("HitchHiking.register.passenger") }}</ion-radio
          >
        </ion-item>
        <ion-item lines="none">
          <ion-radio
            label-placement="end"
            name="hitchHikeDriverOrPassenger"
            color="success"
            slot="start"
            @ionSelect="changeHitchHikeDriverOrPassenger($event)"
            :checked="user.hitchHikePassenger && user.hitchHikeDriver"
            >{{ $t("HitchHiking.register.driverorpassenger") }}</ion-radio
          >
        </ion-item>
      </ion-radio-group>
      <!--
      <div class="text-asterisk text-left" style="line-height: 12px;">
        <small><ion-icon name="information-circle"></ion-icon> {{$t('HitchHiking.register.hikeInfo')}}</small>
      </div>
      -->
      <div
        v-if="
          v$.user.hitchHikeDriver.$error || v$.user.hitchHikePassenger.$error
        "
      >
        <div class="mc-error-label">{{ $t("Validation.required") }}</div>
      </div>
      <br />

      <ion-label class="text-left no-white-space"
        ><p>
          <b>{{ $t("HitchHiking.register.verif-id") }}</b>
        </p></ion-label
      >
      <div class="text-left" style="line-height: 15px">
        <small v-html="$t('HitchHiking.register.verif-id-info')"></small>
      </div>
      <br />

      <ion-button
        class="mc-small-button"
        color="primary"
        fill="outline"
        expand="block"
        @click="$refs.docInput.click()"
      >
        <ion-icon class="ion-margin-end" name="create"></ion-icon>
        {{ $t("HitchHiking.register.verif-id-upload") }}
      </ion-button>
      <div
        class="d-flex align-center justify-center color-success"
        v-if="identityFile"
      >
        <ion-icon name="checkmark-circle" class="mr-3"></ion-icon>
        {{ $t("HitchHiking.register.ready-to-be-send") }}
      </div>
      <input
        ref="docInput"
        style="display: none"
        type="file"
        @change="changeDoc($event)"
      />

      <br />
      <div class="text-asterisk text-left" style="line-height: 14px">
        <small v-html="$t('HitchHiking.register.verif-file-info')"> </small>
      </div>

      <br />

      <ion-item lines="none">
        <ion-checkbox
          label-placement="end"
          name="newsSubscription"
          :value="user.newsSubscription"
          color="success"
          slot="start"
          @ionChange="changeNewsSubscription($event)"
          :checked="user.newsSubscription"
          ><span class="no-white-space">{{
            $t("Register.newsSubscription")
          }}</span></ion-checkbox
        >
      </ion-item>

      <ion-item lines="none">
        <ion-checkbox
          label-placement="end"
          name="userAgreementAccepted"
          :value="user.userAgreementAccepted"
          color="success"
          slot="start"
          @ionChange="changeUserAgreementAccepted($event)"
          :checked="user.userAgreementAccepted"
          ><span class="no-white-space">{{
            $t("Register.userAgreementAccepted")
          }}</span></ion-checkbox
        >
      </ion-item>
      <div v-if="v$.user.userAgreementAccepted.$error">
        <div
          class="mc-error-label"
          v-if="v$.user.userAgreementAccepted.required.$invalid"
        >
          {{ $t("Validation.required") }}
        </div>
        <div
          class="mc-error-label"
          v-if="v$.user.userAgreementAccepted.checked.$invalid"
        >
          {{ $t("Validation.required") }}
        </div>
      </div>

      <br />
      <a class="text-center pointer" v-on:click="$router.push({ name: 'hitchHiking.article', params: { id: 1 } })"
        >Voir les conditions</a
      >
    </div>
  </div>
</template>

<style lang="scss">
.mc-form-register {
  display: block;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  .mc-form-register-input {
    flex: 1;
    flex-direction: column;
    display: flex;
    justify-content: center;
  }

  .label-visible-by-all {
    float: left;
    font-size: 11px;
    opacity: 0.6;
    text-align: start;
    margin-top: 3px;
  }
}

.text-asterisk {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.color-success {
  color: var(--ion-color-success);
}

.mr-3 {
  margin-right: 10px;
}
</style>

<script>
import {
  required,
  email,
  sameAs,
  minLength,
  helpers,
} from "@vuelidate/validators";
import Compressor from "compressorjs";
import { toast } from "../../Shared/Mixin/toast.mixin";
import { hitchHikingStore } from "../HitchHiking.store";
import useVuelidate from "@vuelidate/core";

const checked = (value) => value === true;

const checkedDriver = (value, vm) =>
  value === true || vm.hitchHikePassenger === true;
const checkedPassenger = (value, vm) =>
  value === true || vm.hitchHikeDriver === true;

export default {
  name: "hitchHiking.registerStep3",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      checkedEmail: null,
    };
  },
  mixins: [toast],
  validations() {
    return {
      user: {
        userAgreementAccepted: {
          required,
          checked,
        },
        hitchHikeDriver: {
          checkedDriver,
        },
        hitchHikePassenger: {
          checkedPassenger,
        },
      },
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.registerStore.userToRegister;
      },
      set() {
        this.$store.commit("register_update", this.user);
      },
    },
    identityFile: {
      get() {
        return this.$store.state.hitchHikingStore.identityFile;
      },
    },
  },
  created() {},
  methods: {
    changeDoc(e) {
      const file = e.target.files[0];
      if (file) {
        this.compressFile(file);
      }
    },
    compressFile: function (file) {
      const context = this;
      if (file.type.includes("image")) {
        new Compressor(file, {
          convertSize: 1000000,
          success(result) {
            if (result) {
              context.uploadVerifId(
                new File([result], file.name, { type: result.type })
              );
            }
          },
          error(err) {
            context.presentToast(context.$t("Commons.error"), "danger");
          },
        });
      } else {
        context.uploadVerifId(new File([file], file.name, { type: file.type }));
      }
    },
    uploadVerifId(file) {
      this.$store.commit("hitch_hicking_update", file);
    },
    validate() {
      this.v$.$reset();
      this.v$.$touch();
      if (this.v$.$invalid) {
        return false;
      } else {
        return true;
      }
    },
    changeUserAgreementAccepted(event) {
      event.detail.checked
        ? (this.user.userAgreementAccepted = true)
        : (this.user.userAgreementAccepted = false);
    },
    changeNewsSubscription(event) {
      event.detail.checked
        ? (this.user.newsSubscription = true)
        : (this.user.newsSubscription = false);
    },
    changeHitchHikeDriver(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = true;
        this.user.hitchHikePassenger = false;
      }
    },
    changeHitchHikePassenger(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = false;
        this.user.hitchHikePassenger = true;
      }
    },
    changeHitchHikeDriverOrPassenger(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = true;
        this.user.hitchHikePassenger = true;
      }
    },
  },
};
</script>
